import React, {Component} from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {
  getSchemas
} from "../../../store/actions";
import {getProjectsByAssets,getSchemaById} from "../../../store/actions";
import AssetSchemasTab from "./AssetSchemasTab";
import Modal from "./Modal";

class Tables extends Component {
  state = {
    isOpenTabIndex: -1,
    showmodal: false,
    context: {componentParent: this},

  };

  componentDidMount() {
    const {getSchemas} = this.props;
    getSchemas();
  }

  isOpenTabIndexChange = (id, frommodal) => {
    const {isOpenTabIndex} = this.state;
    const {getProjectsByAssets,getSchemaById} = this.props;

    if (id !== isOpenTabIndex || frommodal) {
      this.setState({isOpenTabIndex: id});
      getProjectsByAssets(id);
      getSchemaById(id);
    } else {
      this.setState({isOpenTabIndex: -1});
    }
  };

  toggle = () => {
    this.setState({
      showmodal: false
    });
  };
  modalOpen = () => {
    this.setState({showmodal: true});
  };


  render() {
    const {allAssetSchemas} = this.props;
    const {isOpenTabIndex,showmodal} = this.state;

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div>
                  <span style={{float: "left", display: "inline"}}>
                    Projects
                  </span>
                  <Button
                    style={{float: "right"}}
                    onClick={this.modalOpen}
                    color="primary"
                  >
                    Add New
                  </Button>
                </div>
                <div
                  className="ag-theme-material"
                  style={{
                    height: "400px",
                    width: "100%",
                    marginTop: "50px"
                  }}
                >
                  {allAssetSchemas && allAssetSchemas.map((schema) => {
                    return <AssetSchemasTab {...schema} key={schema.id} openModal={this.modalOpen}
                                         isOpenTabIndexChange={this.isOpenTabIndexChange} index={schema.id}
                                         isOpenTabIndex={isOpenTabIndex}
                                         isOpen={schema.id === isOpenTabIndex && true || false}/>
                  })}
                </div>
                {allAssetSchemas && <Modal
                  isOpen={showmodal}
                  toggle={this.toggle}
                  isOpenTabIndexChange={this.isOpenTabIndexChange}
                  {...this.props}
                />}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    allAssetSchemas: state.schemas.results,
  }
};
export default withRouter(
  connect(
    mapStateToProps,
    {
      getSchemas,
      getProjectsByAssets,
      getSchemaById,
    }
  )(Tables)
);



// WEBPACK FOOTER //
// ./src/views/Projects/Projects/Table.js